import React, { useEffect } from 'react';
import { BrowserRouter, Routes, Route, Navigate } from 'react-router-dom';
import Layout from './components/Layout';
import Dashboard from './pages/Dashboard';
import CallsList from './pages/CallsList';
import CallDetail from './pages/CallDetail';
import ContactsList from './pages/ContactsList';
import ContactDetail from './pages/ContactDetail';
import Pipeline from './pages/Pipeline';
import Team from './pages/Team';
import Settings from './pages/Settings';
import Onboarding from './pages/onboarding/Onboarding';
import Login from './pages/Login';
import Admin from './pages/Admin';
import InstallPrompt from './components/InstallPrompt';
import './index.css';

import AdminLogin from './pages/AdminLogin';

function PrivateRoute({ children }) {
  const token = localStorage.getItem('cia_token');
  if (!token) return <Navigate to="/login" replace />;
  return children;
}

function AdminRoute({ children }) {
  const token = localStorage.getItem('cia_admin_token');
  if (!token) return <Navigate to="/admin/login" replace />;
  return children;
}

// Clear stale service worker cache on startup to prevent hang
function clearStaleCache() {
  if ('serviceWorker' in navigator) {
    navigator.serviceWorker.getRegistrations().then(registrations => {
      // Only clear if no auth token — fresh install or cleared data
      if (!localStorage.getItem('cia_token')) {
        registrations.forEach(r => r.unregister());
        // Clear caches
        if ('caches' in window) {
          caches.keys().then(keys => keys.forEach(k => caches.delete(k)));
        }
      }
    }).catch(() => {});
  }
}

export default function App() {
  useEffect(() => {
    clearStaleCache();
  }, []);

  return (
    <BrowserRouter>
      <InstallPrompt />
      <Routes>
        <Route path="/signup" element={<Onboarding />} />
        <Route path="/login" element={<Login />} />
        <Route path="/admin/login" element={<AdminLogin />} />
        <Route path="/admin" element={<Navigate to="/admin/login" replace />} />

        <Route path="/admin/dashboard" element={
          <AdminRoute>
            <Admin />
          </AdminRoute>
        } />

        <Route path="/*" element={
          <PrivateRoute>
            <Layout>
              <Routes>
                <Route path="/" element={<Dashboard />} />
                <Route path="/dashboard" element={<Dashboard />} />
                <Route path="/calls" element={<CallsList />} />
                <Route path="/calls/:id" element={<CallDetail />} />
                <Route path="/contacts" element={<ContactsList />} />
                <Route path="/contacts/:id" element={<ContactDetail />} />
                <Route path="/pipeline" element={<Pipeline />} />
                <Route path="/team" element={<Team />} />
                <Route path="/settings" element={<Settings />} />
              </Routes>
            </Layout>
          </PrivateRoute>
        } />
      </Routes>
    </BrowserRouter>
  );
}
